import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';

import './TextInput.scss';

const TextInput = ({ label, error, isValid, isTextArea, ...props }) => {
	const errorElement = error ? <div className="text-input__error">{error}</div> : null;

	const input = !isTextArea ? (
		<input className="text-input__input" {...props} />
	) : (
		<textarea className="text-input__textarea" {...props} />
	);

	const labelElement = label ? <div className="text-input__label">{label}</div> : null;

	return (
		<div
			className={classNames({
				'text-input': true,
				'text-input--error': error,
				'text-input--valid': !error && isValid,
				'text-input--textarea': isTextArea,
			})}
		>
			<div className="text-input__container">
				{labelElement}
				<div className="text-input__input-container">{input}</div>
			</div>
			{errorElement}
		</div>
	);
};

TextInput.propTypes = {
	label: PropTypes.string,
	error: PropTypes.string,
	isValid: PropTypes.bool,
	isTextArea: PropTypes.bool,
};

export default TextInput;
